global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

window.Popper = require('popper.js')
require('bootstrap')

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import state from './store'
const store = new Vuex.Store(state)
Vue.use(store)

import VueRouter from "vue-router"
Vue.use(VueRouter)

import routerClass from './router'
const router = routerClass(store, VueRouter)



/**
 * Assets
 */
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import './assets/font/fontawesome/css/all.min.css'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import 'vue-select/dist/vue-select.css'
import 'nprogress/nprogress.css'

import 'jquery.nicescroll'


/**
 * Firebase And Service Worker
 */
import firebase from 'firebase/app'
import "firebase/messaging";

var firebaseConfig = {
	apiKey: "AIzaSyDKgLJ1CaXU4GnFcX8zEjOPq5QTSKfMihE",
	authDomain: "dukcapil-jembrana.firebaseapp.com",
	projectId: "dukcapil-jembrana",
	storageBucket: "dukcapil-jembrana.appspot.com",
	messagingSenderId: "786321567019",
	appId: "1:786321567019:web:3b9294c82798185815696e",
	measurementId: "G-XH66L4FVF5"
}

firebase.initializeApp(firebaseConfig)

if ('serviceWorker' in navigator) {
	navigator.serviceWorker.register('/service-worker.js')
	.then(reg => {
		const messaging = firebase.messaging()
		messaging.useServiceWorker(reg)
		console.log('Service Worker Registered')
	})
	.catch(err => console.error(err))

	// navigator.serviceWorker.register('/firebase-messaging-sw.js')
	// .then(reg => {
	// 	const messaging = firebase.messaging()
	// 	messaging.useServiceWorker(reg)
	// 	console.log('Firebase Messaging Service Worker Registered')
	// })
	// .catch(err => console.error(err))

	// navigator.serviceWorker.register("/service-worker.js")
	// .then(res => console.log("Service Worker Registered"))
	// .catch(err => console.log("Service Worker Not Registered", err))
} else {
	// happens when the app isn't served over HTTPS or if the browser doesn't support service workers
	console.warn('Service Worker not available');
}


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
import App from './App.vue'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 new Vue({
	router,
	render: h => h(App),
	store: store
}).$mount('#app')